import { c as _c } from "react/compiler-runtime";
import React from "react";
import RichText from "@/components/RichText";
import type { ResolvedPromoContent } from "../types";
import { buildBackground } from "./promoHelpers";
import { LinkWrapper } from "./LinkWrapper";
import { PromoCountdown } from "../countdown/PromoCountdown";
interface CardVariantProps {
  promo: ResolvedPromoContent;
  textColor: string;
  ctaBackground: string;
  ctaTextColor: string;
  href: string | null;
  isExternal: boolean;
  fillHeight?: boolean;
}
export const CardVariant: React.FC<CardVariantProps> = t0 => {
  const $ = _c(43);
  const {
    promo,
    textColor,
    ctaBackground,
    ctaTextColor,
    href,
    isExternal,
    fillHeight
  } = t0;
  const t1 = `relative overflow-hidden rounded-lg cursor-pointer transition-transform hover:scale-[1.01] ${fillHeight ? "h-full min-h-48" : ""}`;
  let t2;
  if ($[0] !== promo) {
    t2 = buildBackground(promo, "card");
    $[0] = promo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== textColor) {
    t3 = {
      background: t2,
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: textColor
    };
    $[2] = t2;
    $[3] = textColor;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 bg-linear-to-t from-black/60 via-black/30 to-black/10" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== promo.badge) {
    t5 = promo.badge && <div className="flex items-center justify-between gap-2 mb-2 sm:mb-3"><div className="inline-block bg-white text-xs font-bold px-2 sm:px-3 py-1 rounded backdrop-blur-sm uppercase">{promo.badge}</div></div>;
    $[6] = promo.badge;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== promo.headline) {
    t6 = promo.headline && <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2">{promo.headline}</h3>;
    $[8] = promo.headline;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== promo.description) {
    t7 = promo.description && <RichText content={promo.description} className="opacity-80 text-base mb-3 sm:mb-4 line-clamp-2" />;
    $[10] = promo.description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== ctaBackground || $[13] !== ctaTextColor || $[14] !== promo.countdown || $[15] !== textColor) {
    t8 = promo.countdown && <div className="mb-3 sm:mb-4"><PromoCountdown countdown={promo.countdown} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} interactive={false} /></div>;
    $[12] = ctaBackground;
    $[13] = ctaTextColor;
    $[14] = promo.countdown;
    $[15] = textColor;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div>{t5}{t6}{t7}{t8}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== promo.highlights) {
    t10 = promo.highlights && promo.highlights.length > 0 && <div className="flex items-center gap-3 sm:gap-4 md:gap-6">{promo.highlights.map(_temp)}</div>;
    $[22] = promo.highlights;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== ctaBackground || $[25] !== ctaTextColor || $[26] !== promo.ctaText) {
    t11 = promo.ctaText && <span className="px-4 sm:px-6 py-2 sm:py-2.5 rounded-full font-bold text-sm hover:opacity-90 transition-opacity shadow-sm whitespace-nowrap text-center" style={{
      backgroundColor: ctaBackground,
      color: ctaTextColor
    }}>{promo.ctaText}</span>;
    $[24] = ctaBackground;
    $[25] = ctaTextColor;
    $[26] = promo.ctaText;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">{t10}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t9) {
    t13 = <div className="relative p-6 h-full flex flex-col justify-between">{t9}{t12}</div>;
    $[31] = t12;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t1 || $[35] !== t13 || $[36] !== t3) {
    t14 = <div className={t1} style={t3}>{t4}{t13}</div>;
    $[34] = t1;
    $[35] = t13;
    $[36] = t3;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const content = t14;
  let t15;
  if ($[38] !== content || $[39] !== fillHeight || $[40] !== href || $[41] !== isExternal) {
    t15 = <LinkWrapper href={href} isExternal={isExternal} fillHeight={fillHeight}>{content}</LinkWrapper>;
    $[38] = content;
    $[39] = fillHeight;
    $[40] = href;
    $[41] = isExternal;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
function _temp(highlight, index) {
  return <div key={index}><div className="text-base sm:text-lg md:text-xl font-bold">{highlight.value}</div><div className="text-xs opacity-70">{highlight.label}</div></div>;
}